import React from 'react';
import Table from '../../components/common/Table';
import { CourseDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface CourseTableProps {
  data: (CourseDTO & { countryName?: string })[];
  handleEdit: (row: CourseDTO) => void;
  handleDelete: (row: CourseDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const CourseTable: React.FC<CourseTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        { label: 'Name', key: 'name' },
        { label: 'Address', key: 'address' },
        { label: 'Country', key: 'countryName' },
        {
          label: 'Active',
          key: 'active',
          render: (row: CourseDTO) => renderBooleanBadge(row.active ?? false),
        },
        { label: 'Total Holes', key: 'totalHoles' },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default CourseTable;
